import { Component, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface ChipItem {
  id: string;
  label?: string;
  labelKey?: string;
  count?: number;
  /** Status dot color; omitted for the "Alle" chip. */
  color?: string;
  /** Dropdown chevron (dashboard filter chips). */
  dropdown?: boolean;
}

/** Horizontal scrolling filter chips (design: status chips, dashboard filter chips). */
@Component({
  selector: 'mbm-chips',
  imports: [TranslateModule],
  templateUrl: './mbm-chips.component.html',
  styleUrl: './mbm-chips.component.scss',
})
export class MbmChipsComponent {
  readonly chips = input.required<ChipItem[]>();
  readonly selectedId = model<string>('');
  /** Set of chip ids rendered as "on" regardless of selectedId (multi-filter chips). */
  readonly activeIds = input<readonly string[]>([]);
  /** Emitted on every click, including repeated clicks on the same chip. */
  readonly chipClick = output<string>();

  protected isOn(chip: ChipItem): boolean {
    if (chip.dropdown) return this.activeIds().includes(chip.id);
    return this.selectedId() === chip.id || this.activeIds().includes(chip.id);
  }

  protected select(chip: ChipItem): void {
    this.chipClick.emit(chip.id);
    // Dropdown chips open a picker; their on-state comes only from activeIds.
    if (!chip.dropdown) this.selectedId.set(chip.id);
  }
}
